const FETCH_MY_STORIES = 'studio/myPage/FETCH_MY_STORIES';

const RESET = 'studio/myPage/RESET';


export default {
  FETCH_MY_STORIES,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/myPage/types.js